export enum UserFlow {
  Green = 'Green',
  Yellow = 'Yellow',
  Red = 'Red',
}
